const today = new Date();
today.setHours(0, 0, 0, 0);

const state = {
  center: [19.035, 47.4835],
  zoom: 11,
  mode: 'heatmap',
  date: today,
  activeStatuses: ["beteg", "kontakt", "megfigyelt", "gyogyult", "elhunyt"],
  thematicMapStatus: "fertozott",
  activePerson: undefined,
  homeQuarantine: true,
  populationProportioned: false,
  filterByPrimaryAddress: false,
  showLockdowns: false,
  adminAreaType: "county",
  showAllLabels: false,
  lastChangeOfRenderParams: new Date().getTime(),
  zeroColor: "#c8d5b9",
  startColor: "#f9cda8",
  stopColor: "#550000",
  baseOfScale: 1
};

const actions = {

};

const mutations = {
  setZoom(state, zoom) {
    state.zoom = zoom
  },
  setCenter(state, center) {
    state.center = center
  },
  setMode(state, mode) {
    state.mode = mode
  },
  setDate(state, date) {
    if (state.date !== date) {
      state.date = date
      state.lastChangeOfRenderParams = new Date().getTime()
    }
  },
  setActiveStatuses(state, statuses) {
    if (state.activeStatuses.length !== statuses.length) {
      state.activeStatuses = statuses
      state.lastChangeOfRenderParams = new Date().getTime()
    }
  },
  setThematicMapStatus(state, status) {
    if (state.thematicMapStatus !== status) {
      state.thematicMapStatus = status;
    }
  },
  setActivePerson(state, person) {
    if ((state.activePerson && person && state.activePerson._id !== person._id) ||
      state.activePerson !== person
    ) {
      state.activePerson = person
      state.lastChangeOfRenderParams = new Date().getTime()
    }
  },
  setHomeQuarantine(state, homeQuarantine) {
    state.homeQuarantine = homeQuarantine
  },
  setPopulationProportioned(state, populationProportioned) {
    if (state.populationProportioned !== populationProportioned) {
      state.populationProportioned = populationProportioned
    }
  },
  setFilterByPrimaryAddress(state, filterByPrimaryAddress) {
    if (state.filterByPrimaryAddress !== filterByPrimaryAddress) {
      state.filterByPrimaryAddress = filterByPrimaryAddress
      state.lastChangeOfRenderParams = new Date().getTime()
    }
  },
  setShowLockdowns(state, value) {
    state.showLockdowns = value
  },
  setAdminAreaType(state, type) {
    if (state.adminAreaType !== type) {
      state.adminAreaType = type
      state.lastChangeOfRenderParams = new Date().getTime()
    }
  },
  setShowAllLabels(state, value) {
    if (state.showAllLabels !== value) {
      state.showAllLabels = value
    }
  },
  setZeroColor(state, color) {
    if (state.zeroColor !== color) {
      state.zeroColor = color
    }
  },
  setStartColor(state, color) {
    if (state.startColor !== color) {
      state.startColor = color
    }
  },
  setStopColor(state, color) {
    if (state.stopColor !== color) {
      state.stopColor = color
    }
  },
  setBaseOfScale(state, value) {
    if (state.baseOfScale !== value) {
      state.baseOfScale = value
    }
  }

};

export const map = {
  namespaced: true,
  state,
  actions,
  mutations
};
